// @flow
import React, { Component } from 'react';
import moment from 'moment';
import styled, { withTheme } from 'styled-components';
import { DateRange } from 'react-date-range';
import { translate } from 'react-i18next';
import ArrowDown from 'material-ui/svg-icons/hardware/keyboard-arrow-down';

import FlatButton from 'material-ui/FlatButton';
import Popover from 'material-ui/Popover'; // TODO: check for issue about popover https://github.com/mui-org/material-ui/issues/8040
import Menu from 'material-ui/Menu';
import { WEEK_START } from 'common/domain/week';
import { Icon } from '../modules/ui/components/NotificationContent';

const PickerPopover = styled.div`
  display: flex;
  flex-flow: column;
  width: 320px;
  padding-top: 19px;
  padding-bottom: 19px;
  background-color: white;
  text-align: center;
`;

const calendarButtonStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '30px',
  height: '30px',
  minWidth: '30px',
  marginRight: '10px',
};


const DatePickerTheme = (theme) => {
  return {
    Day: {
      width: theme.metrics.icon.small.width,
      height: theme.metrics.icon.small.width,
    },

    DaySelected: {
      background: theme.colors.primary,
    },

    MonthButton: {
      background: 'none',
    },
  };
};

type Props = {
  date: moment;
  disabled: ?boolean;
  theme: Object;
  labelStyle?: any;

  minDate?: moment;
  maxDate?: moment;

  style?: any;

  suffix?: string;

  t: any;

  showIcon: boolean;
}

type State = {
  opened?: boolean;
  anchor?: any;
  onDateChange: ({ date: moment }) => void;
}

class DatePicker extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      opened: false,
      anchor: null,
      onDateChange: props.onDateChange,
    };
  }

  onClick = (event: any) => {
    event.preventDefault();
    this.setState({
      opened: true,
      anchor: event.currentTarget,
    });
  }

  onDatePicked = (range) => {
    this.state.onDateChange(range.startDate);
    this.onClose();
  }

  onClose = () => {
    this.setState({
      opened: false,
    });
  }

  render() {
    const { date, theme, t, labelStyle, suffix, minDate, maxDate, showIcon } = this.props;
    const { opened, anchor } = this.state;

    return (
      <div style={this.props.style} >
        {showIcon && <FlatButton onClick={this.onClick} style={calendarButtonStyle}>
          <Icon style={{ fontSize: '30px' }} className="material-icons">date_range</Icon>
          </FlatButton>}
        {!showIcon && <FlatButton
          label={`${t('date.text', { value: date })} ${suffix || ''}`}
          labelPosition="before"
          onClick={this.onClick}
          disabled={this.props.disabled}
          labelStyle={{
            ...theme.fonts.style.secondary,
            fontSize: 22,
            textTransform: 'none',
            color: !this.props.disabled ? theme.colors.primaryText : theme.colors.disabled,
            ...(labelStyle || {}),
          }}
          icon={<ArrowDown />}
        />}
        <Popover
          animated
          open={opened}
          anchorEl={anchor}
          anchorOrigin={{ horizontal: 'middle', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'middle', vertical: 'top' }}
          onRequestClose={this.onClose}
          style={{ backgroundColor: 'transparent' }}
        >
          <Menu desktop listStyle={{ paddingTop: 0, paddingBottom: 0 }} >
            <PickerPopover>
              <DateRange
                calendars={1}
                startDate={date}
                endDate={date}
                minDate={minDate}
                maxDate={maxDate}
                onChange={this.onDatePicked}
                theme={DatePickerTheme(theme)}
                firstDayOfWeek={WEEK_START}
                style={{ backgroundColor: 'transparent' }}
              />
            </PickerPopover>
          </Menu>
        </Popover>
      </div>
    );
  }
}

export default withTheme(translate('common')(DatePicker));



// WEBPACK FOOTER //
// ./src/common/components/DatePicker.js